import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ComponentsModule } from "../../components/form-components.module";
import { LayoutComponent } from "./layout.component";
import { HttpService } from "src/providers/http.service";

@NgModule({
    imports: [ ComponentsModule ],
    declarations: [LayoutComponent],
    providers: [ HttpService ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  })

  export class LayoutModule {}
